export const CollectionsMenuList = [
  {
    title: "Dashboard",
    iconStyle: imagepaths.Dashboard,
    iconActive: imagepaths.DashboardActive,
    to: "/app/collectionshome",
    id: ["collectionshome"],
  },
  {
    title: "Loan Details",
    iconStyle: imagepaths.applicationCheckImg,
    iconActive: imagepaths.applicationCheckActiveImg,
    to: "/app/loandetails",
    id: ["loandetails", "loandetailswriteoffview"]
  },
  {
    title: "Repayment",
    iconStyle: imagepaths.reportsIcon,
    iconActive: imagepaths.reportsIconActive,
    to: "/app/repaymentreports",
    id: ["repaymentreports"]
  },
];
